import React from "react";

// Line-icon set for the Fractional Services page, matching the prototype's
// stroke style (24x24, 1.6 stroke, round caps).
const EcoIcon = ({ name, size = 24, color = "currentColor" }) => {
    const p = {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: 1.6,
        strokeLinecap: "round",
        strokeLinejoin: "round",
    };
    switch (name) {
        case "pm":
            return <svg {...p}><path d="M3 6h18M3 12h18M3 18h12" /><circle cx="20" cy="18" r="2" /></svg>;
        case "ops":
            return <svg {...p}><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M2 12h3M19 12h3M4.93 19.07l2.12-2.12M16.95 7.05l2.12-2.12" /></svg>;
        case "design":
            return <svg {...p}><path d="M12 2 2 12l10 10 10-10z" /><path d="M2 12h20M12 2v20" /></svg>;
        case "check":
            return <svg {...p}><path d="M5 12l5 5L20 7" /></svg>;
        case "arrow":
            return <svg {...p}><path d="M5 12h14M13 6l6 6-6 6" /></svg>;
        case "close":
            return <svg {...p}><path d="M18 6 6 18M6 6l12 12" /></svg>;
        case "plus":
            return <svg {...p}><path d="M12 5v14M5 12h14" /></svg>;
        default:
            return <svg {...p}><circle cx="12" cy="12" r="9" /></svg>;
    }
};

export default EcoIcon;
